import { AkEditIcon, AkCopyIcon, AkTrashIcon } from '@fuegokit/fuegoicons-react';
import React__default from 'react';
import styled from 'styled-components';
import sx from '../../sx.js';
import { themeGet } from '../../utils/theme-get.js';
import Box from '../Box/Box.js';
import Placeholder from '../Placeholder/Placeholder.js';
import { AtlasButtonGroup } from '../AtlasButton/AtlasButtonGroup.js';
import AtlasButton from '../AtlasButton/AtlasButton.js';
import VisuallyHidden from '../VisuallyHidden/VisuallyHidden.js';

// ------------------------------
/** * Wrapper component for actions in a collapse or footer menu */
const Wrapper = styled(Box).withConfig({
  displayName: "RuleItemUserActions__Wrapper",
  componentId: "sc-1hpg4ma-0"
})(["display:flex;justify-content:space-between;border-top:1px solid;border-top-color:", ";margin-top:", ";padding-top:", ";width:100%;", ""], themeGet('colors.border.default'), themeGet('space.2'), themeGet('space.2'), sx);

// this is just a placeholder
const RuleItemUserActions = ({
  children,
  testId,
  ...props
}) => {
  return /*#__PURE__*/React__default.createElement(Wrapper, null, /*#__PURE__*/React__default.createElement(Box, {
    sx: {
      marginRight: 'auto',
      display: 'flex',
      width: '254px'
    }
  }, /*#__PURE__*/React__default.createElement(Placeholder, {
    height: "44px",
    label: "Avatar + relative time component"
  })), /*#__PURE__*/React__default.createElement(Box, {
    sx: {
      marginLeft: 'auto',
      display: 'flex',
      width: '254px',
      alignItems: 'center',
      justifyContent: 'flex-end'
    }
  }, /*#__PURE__*/React__default.createElement(AtlasButtonGroup, {
    appearance: "subtle",
    sx: {
      color: 'red'
    }
  }, /*#__PURE__*/React__default.createElement(AtlasButton, {
    leadingIcon: AkEditIcon
  }, /*#__PURE__*/React__default.createElement(VisuallyHidden, null, "Edit")), /*#__PURE__*/React__default.createElement(AtlasButton, {
    leadingIcon: AkCopyIcon
  }, /*#__PURE__*/React__default.createElement(VisuallyHidden, null, "Edit")), /*#__PURE__*/React__default.createElement(AtlasButton, {
    leadingIcon: AkTrashIcon
  }, /*#__PURE__*/React__default.createElement(VisuallyHidden, null, "Delete")))), children);
};
RuleItemUserActions.displayName = "RuleItemUserActions";
RuleItemUserActions.displayName = 'RuleItemUserActions';
var RuleItemUserActions$1 = RuleItemUserActions;

export { RuleItemUserActions$1 as default };
